import styled from "styled-components";
import Lottie from "lottie-react";
import { Flex, Text } from "rebass/styled-components";

import { Container } from "../styledComponents";
import remixProcessing from "../../../../animations/remixing.json";
import { AdRemovalCTA } from "MVVM/Components/AdRemovalCTA";
import { LoadingSpinner } from "MVVM/Components/Lottie";
import theme from "theme/themeThree";
import { useHistory } from "react-router-dom";
import { URLS } from "utils";

export const FinalizingContainer = ({
  finalizing,
  loadingAd,
  activeAd,
  closeModal,
}: {
  finalizing: boolean;
  loadingAd: boolean;
  activeAd: unknown;
  closeModal: () => void;
}) => {
  const history = useHistory();
  return (
    <Container
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
      minHeight={450}
      maxHeight={300}
    >
      <LayeredContent visible={activeAd === "clip-modal"}>
        <FinalizingAdContainer>
          <Text variant="text.labelMedium" color={theme.colors.chalk} mb={2}>
            This clip is sponsored by:
          </Text>
          <AdParentContainer>
            <AdTargetContainer id="quick-edit-ad" />
          </AdParentContainer>
          <AdRemovalCTA
            onUpgrade={() => {
              history.push("/upgrade");
              closeModal();
            }}
          />
        </FinalizingAdContainer>
      </LayeredContent>
      <LayeredContent visible={!!loadingAd && activeAd !== "clip-modal"}>
        <LoadingSpinner height={50} width={50} />
      </LayeredContent>

      <LayeredContent
        visible={finalizing && activeAd !== "clip-modal" && !loadingAd}
      >
        <Text variant="text.headingXSmall" pb={3}>
          Your clip is on the way...
        </Text>
        <Text variant="text.bodySmall" color={theme.colors.chalk}>
          Come back here or visit your profile in a few minutes to watch it!
        </Text>
        <Lottie
          animationData={remixProcessing}
          loop={true}
          style={{ height: 200, width: 200 }}
        />
      </LayeredContent>
    </Container>
  );
};

const AdParentContainer = styled(Flex)`
  aspect-ratio: 16/9;
  position: relative;
  width: 300px;
`;

const AdTargetContainer = styled(Flex)`
  height: 100%;
  padding: 10px;
  width: 100%;
`;

const FinalizingAdContainer = styled(Flex)`
  align-items: center;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
`;

const LayeredContent = styled.div<{ visible: boolean }>`
  align-items: center;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 20px;
  position: absolute;
  right: 20px;
  top: 0;
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
`;
